<ziro-top-nav></ziro-top-nav>
<div class="ziro-content">
  <div data-automation="base-container-side-nav">
    <ziro-side-navigation
      [title]="'tkey;api.page.reports.navlink'"
      [navSections]="navSections()"
      [navProps]="navProps()"
    ></ziro-side-navigation>
  </div>
  <div class="container-fluid overflow-hidden px-0">
    @if (pageDisabled) {
      <div
        class="offset-md-1 col-md-10 ziro-page-alert alert border-warning"
        data-automation="ziro-page-disabled-alert"
      >
        <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="pageDisabledMessage | escapeHtml"></div>
      </div>
    }
    @if (!pageDisabled) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
